import { MaterialReactTable } from "material-react-table";
import { MRT_Localization_ES } from "material-react-table/locales/es";
import {
  Container,
  Box,
  Typography,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  Button,
  Chip,
  Autocomplete,
  TextField,
} from "@mui/material";
import { createTheme, ThemeProvider, useTheme } from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FilesService } from "../filesService/FilesService";
import PeriodActionMenu from "../rowActions/RowActions";
import RejectModal from "../modals/RejectModal";
import axios from "axios";
import { UrlApi } from "../../../services/apirest";
import { useToast } from "../../../Hooks/UseToast";
import ApproveModal from "../modals/ApproveModal";
import OdsModal from "../modals/OdsModal";
import AgregarSolicitud from "../modals/AgregarSolicitud";
import ArticleIcon from "@mui/icons-material/Article";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import DownloadingIcon from "@mui/icons-material/Downloading";
import BulkApprove from "../modals/BulkApprove";

const RRHH = localStorage.getItem("adminrrhh") === "1";
const USERNAME = localStorage.getItem("user");

const DataTable = ({
  employees = [],
  year,
  setYear,
  branch,
  setBranch,
  getEmployees,
}) => {
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [rejectModalOpen, setRejectModalOpen] = useState(false);
  const [approveModalOpen, setApproveModalOpen] = useState(false);
  const [selectedPeriod, setSelectedPeriod] = useState(null);
  const [odsModalOpen, setOdsModalOpen] = useState(false);
  const [bulkApproveModalOpen, setBulkApproveModalOpen] = useState(false);

  const { showToast, Toast } = useToast();

  const navigate = useNavigate();
  // ---- helpers ----
  const fmtDate = (d) => {
    if (!d) return "-";
    // backend devuelve strings "YYYY-MM-DD" o Date; soportamos ambos
    const date =
      typeof d === "string" ? new Date(`${d}T00:00:00`) : new Date(d);
    if (Number.isNaN(date.getTime())) return "-";
    return new Intl.DateTimeFormat("es-AR").format(date);
  };

  const handleRejectSubmit = async (e, motivo) => {
    e?.preventDefault();
    if (!selectedPeriod) return;
    let success = false;
    try {
      const { employeeId, periodId, year } = selectedPeriod;

      const response = await axios.post(
        `${UrlApi}/vacations/${employeeId}/periods/${periodId}/reject`,
        {
          year,
          reason: motivo || "Sin motivo especificado",
          rejectedBy: USERNAME || "Admin",
        }
      );

      setTimeout(() => {
        getEmployees();
      }, 500);
      await getEmployees();

      if (response.status === 200) success = true;
      showToast("Solicitud rechazada con éxito.", "success");
    } catch (err) {
      console.error("Error al rechazar:", err);
      showToast("No se pudo rechazar la solicitud.", "error");
    } finally {
      if (success) await getEmployees();
      setRejectModalOpen(false);
      setSelectedPeriod(null);
    }
  };

  const GenerateMultipleResumes = async () => {
    try {
      const employeesIds = employeesFilter.map((e) => e.empleadoId);
      // console.log("Legajos: ", employeesIds);
      const url = `${UrlApi}/vacations/generate/constancias-masivas/${Number(
        year
      )}`;
      const response = await fetch(url, {
        method: "POST",
        body: JSON.stringify({ legajos: employeesIds }),
        headers: { "Content-Type": "application/json" },
      });

      if (response.ok) {
        const pdfBlob = await response.blob();
        const url = window.URL.createObjectURL(pdfBlob);
        const link = document.createElement("a");
        link.href = url;

        const contentDisposition = response.headers.get("Content-Disposition");
        let filename = `constancias_aprobadas_${branch}_${year}.pdf`;

        if (contentDisposition) {
          const filenameMatch =
            contentDisposition.match(/filename="?([^"]*)"?/i);
          if (filenameMatch && filenameMatch[1]) {
            filename = filenameMatch[1].replace(/['"]/g, "");
          }
        }

        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);

        showToast(
          "descarga del PDF de periodos aprobados completada.",
          "success"
        );
      } else {
        const errorText = await response.text();
        let errorMessage = "Error en la aprobación. Detalles en consola.";
        let consoleError = errorText;

        try {
          const errorJson = JSON.parse(errorText);
          errorMessage = errorJson.message || errorJson.error || errorMessage;
        } catch (e) {
          console.error(
            `[BulkApprove Error] Status: ${response.status}`,
            consoleError
          );
          showToast(errorMessage, "error");
        }
      }
    } catch (error) {
      console.error("[DataTable Fetch Error]", error);
      showToast("Error de red o procesamiento. Revisa la conexión.", "error");
    }
  };

  const handleApproveSubmit = async (e, motivo) => {
    e?.preventDefault();
    if (!selectedPeriod) return;
    try {
      const { employeeId, periodId, year } = selectedPeriod;

      const response = await axios.post(
        `${UrlApi}/vacations/${employeeId}/periods/${periodId}/approve`,
        { year, reason: motivo || "Sin motivo especificado" }
      );

      showToast("Solicitud aprobada con éxito.", "success");
      await getEmployees();
    } catch (err) {
      console.error("Error al aprobar:", err);
      showToast("No se pudo aprobar la solicitud.", "error");
    } finally {
      setApproveModalOpen(false);
      setSelectedPeriod(null);
    }
  };

  const estadoChip = (estado) => {
    switch (estado) {
      case 2:
        return <Chip label="Aprobado" size="small" color="success" />;
      case 3:
        return <Chip label="Rechazado" size="small" color="error" />;
      case 1:
        return <Chip label="Pendiente" size="small" color="warning" />;
      default:
        return <Chip label="-" size="small" />;
    }
  };

  const branchLS = (localStorage.getItem("suc_auth") || "")
    .split(",")
    .map((x) => x.trim()) // limpia espacios
    .filter(Boolean); // elimina vacíos

  const [branches, setBranches] = useState([]);

  const getBranches = async () => {
    try {
      const response = await fetch(`${UrlApi}/sucursales/escencial`);
      const data = await response.json();
      setBranches(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error("Error cargando sucursales:", err);
    }
  };

  useEffect(() => {
    getBranches();
  }, []);

  const branchesFilter = branches.filter((b) =>
    branchLS.includes(String(b.id))
  );
  const employeesFilter = employees.filter((e) =>
    branchLS.includes(String(e.branchId))
  );

  const initialState = useMemo(
    () => ({
      density: "compact",
      showGlobalFilter: true,
      pagination: { pageIndex: 0, pageSize: 10 },
    }),
    []
  );

  const muiSearchTextFieldProps = useMemo(
    () => ({
      placeholder: "Buscar...",
      sx: { minWidth: "18rem", backgroundColor: "#ffffff" },
      variant: "outlined",
      color: "primary",
      size: "small",
    }),
    []
  );

  const tableHeadCellProps = useMemo(
    () => ({
      align: "left",
      sx: {
        fontSize: 16,
        color: "white",
        fontWeight: "normal",
        backgroundColor: "#2471A3",
        borderColor: "black",
      },
    }),
    []
  );

  // ---- columnas que SI matchean backend ----
  const columns = useMemo(
    () => [
      { header: "Empleado", accessorKey: "empleadoId", size: 70 },
      { header: "Nombre", accessorKey: "nombre", size: 220 },
      { header: "Suc", accessorKey: "branchId", size: 60 },
      { header: "Año", accessorKey: "anio", size: 60 },
      { header: "Días totales", accessorKey: "totalDays", size: 70 },
      { header: "Restantes", accessorKey: "remainingDays", size: 70 },

      {
        header: "Inicio 1",
        accessorFn: (row) => fmtDate(row.inicio_1),
        size: 90,
      },
      {
        header: "Hasta 1",
        accessorFn: (row) => fmtDate(row.hasta_1),
        size: 90,
      },
      {
        header: "Estado 1",
        accessorFn: (row) => row.estado_1,
        Cell: ({ cell }) => estadoChip(cell.getValue()),
        size: 110,
      },
      { header: "Dias 1", accessorKey: "dias_1", size: 30 },
      {
        header: "Inicio 2",
        accessorFn: (row) => fmtDate(row.inicio_2),
        size: 90,
      },
      {
        header: "Hasta 2",
        accessorFn: (row) => fmtDate(row.hasta_2),
        size: 90,
      },
      {
        header: "Estado 2",
        accessorFn: (row) => row.estado_2,
        Cell: ({ cell }) => estadoChip(cell.getValue()),
        size: 110,
      },
      { header: "Dias 2", accessorKey: "dias_2", size: 30 },

      {
        header: "Inicio 3",
        accessorFn: (row) => fmtDate(row.inicio_3),
        size: 90,
      },
      {
        header: "Hasta 3",
        accessorFn: (row) => fmtDate(row.hasta_3),
        size: 90,
      },
      {
        header: "Estado 3",
        accessorFn: (row) => row.estado_3,
        Cell: ({ cell }) => estadoChip(cell.getValue()),
        size: 110,
      },
      { header: "Dias 3", accessorKey: "dias_3", size: 30 },
    ],
    []
  );

  // ---- tema ----
  const globalTheme = useTheme();
  const tableTheme = useMemo(
    () =>
      createTheme({
        palette: {
          mode: globalTheme.palette.mode,
          primary: globalTheme.palette.primary,
          info: { main: "rgb(255,122,0)" },
          background: {
            default:
              globalTheme.palette.mode === "light"
                ? "rgb(234, 239, 241)"
                : "#000",
          },
        },
        typography: {
          button: { textTransform: "none", fontSize: "1rem" },
        },
        components: {
          MuiTooltip: {
            styleOverrides: { tooltip: { fontSize: "0.8rem" } },
          },
        },
      }),
    [globalTheme]
  );

  // Años sugeridos (modificá a gusto)
  const years = useMemo(() => {
    const y = new Date().getFullYear();
    return [y - 1, y, y + 1, y + 2];
  }, []);

  return (
    <Container maxWidth={false} sx={{ width: "100%", mt: 1 }}>
      <Box mt={2} mb={4}>
        <ThemeProvider theme={tableTheme}>
          <MaterialReactTable
            enableToolbarInternalActions
            autoResetPageIndex={false}
            enableGrouping
            layoutMode="grid"
            muiTableHeadCellProps={tableHeadCellProps}
            muiTableBodyCellProps={{
              align: "left",
              sx: {
                padding: "6px 0px",
                borderColor: "black",
                backgroundColor: "#ffffff",
                whiteSpace: "normal",
                overflowWrap: "break-word",
              },
            }}
            enableColumnActions
            enableColumnFilters={false}
            enableHiding={false}
            enableDensityToggle={false}
            localization={MRT_Localization_ES}
            enableColumnDragging={false}
            initialState={initialState}
            muiSearchTextFieldProps={muiSearchTextFieldProps}
            columns={columns}
            data={Array.isArray(employeesFilter) ? employeesFilter : []}
            enableStickyFooter
            enableRowActions
            positionActionsColumn="first"
            renderTopToolbarCustomActions={() => (
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 1,
                  width: "100%",
                }}
              >
                <Typography variant="h3" sx={{ fontSize: 22, mb: 1 }}>
                  Gestor de vacaciones
                </Typography>

                <Box
                  sx={{
                    display: "flex",
                    gap: 2,
                    alignItems: "center",
                    flexWrap: "wrap",
                  }}
                >
                  <FormControl size="small" sx={{ minWidth: 100 }}>
                    <InputLabel>Año</InputLabel>
                    <Select
                      value={year ?? ""}
                      label="Año"
                      onChange={(e) => setYear(Number(e.target.value))}
                    >
                      {years.map((y) => (
                        <MenuItem key={y} value={y}>
                          {y}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>

                  <Autocomplete
                    size="small"
                    sx={{ minWidth: 140 }}
                    options={[{ id: "", nombre: "Todas" }, ...branchesFilter]}
                    getOptionLabel={(option) => option.nombre}
                    value={
                      branch === null
                        ? { id: "", nombre: "Todas" }
                        : branchesFilter.find((b) => b.id === branch) || null
                    }
                    onChange={(_, newValue) => {
                      if (!newValue || newValue.id === "") {
                        setBranch(null);
                      } else {
                        setBranch(Number(newValue.id));
                      }
                    }}
                    renderInput={(params) => (
                      <TextField {...params} label="Sucursal" />
                    )}
                  />
                  {RRHH && (
                    <Button
                      variant="contained"
                      size="small"
                      startIcon={<ArrowForwardIcon />}
                      onClick={() => navigate("/vacacionesRechazadas")}
                    >
                      Rechazadas
                    </Button>
                  )}
                  {RRHH && (
                    <Button
                      disabled={!branch}
                      variant="contained"
                      size="small"
                      startIcon={<DownloadingIcon />}
                      sx={{
                        backgroundColor: "#6900AF",
                        "&:hover": {
                          backgroundColor: "#6200AF",
                        },
                      }}
                      onClick={() => setBulkApproveModalOpen(true)}
                    >
                      Aprobar sucursal
                    </Button>
                  )}
                  {RRHH && (
                    <Button
                      disabled={!branch || !year}
                      variant="contained"
                      size="small"
                      startIcon={<DownloadingIcon />}
                      sx={{
                        backgroundColor: "#00b862ff",
                        "&:hover": {
                          backgroundColor: "#037c44ff",
                        },
                      }}
                      onClick={GenerateMultipleResumes}
                    >
                      Constancias
                    </Button>
                  )}
                  <Button
                    startIcon={<PictureAsPdfIcon />}
                    variant="contained"
                    size="small"
                    sx={{
                      backgroundColor: "#730000",
                      "&:hover": {
                        backgroundColor: "#a00000ff",
                      },
                    }}
                    onClick={() => FilesService.downloadAnnualPdf(branch, year)}
                    disabled={!branch}
                  >
                    PDF
                  </Button>
                  {RRHH && (
                    <Button
                      startIcon={<ArticleIcon />}
                      variant="contained"
                      size="small"
                      sx={{
                        backgroundColor: "#007308",
                        "&:hover": {
                          backgroundColor: "#00990aff",
                        },
                      }}
                      onClick={() => setOdsModalOpen(true)}
                    >
                      CSV
                    </Button>
                  )}
                </Box>
              </Box>
            )}
            renderRowActionMenuItems={({ row }) => (
              <PeriodActionMenu
                row={row.original}
                onEdit={(row, periodId, periodNumber) => {
                  setSelectedPeriod({
                    employeeId: row.empleadoId,
                    periodId,
                    periodNumber,
                    year: row.anio,
                    rowData: row,
                  });
                  setEditModalOpen(true);
                }}
                onApprove={(row, periodId) => {
                  setSelectedPeriod({
                    employeeId: row.empleadoId,
                    periodId,
                    year: row.anio,
                  });
                  setApproveModalOpen(true);
                }}
                onReject={(row, periodId) => {
                  setSelectedPeriod({
                    employeeId: row.empleadoId,
                    periodId,
                    year: row.anio,
                  });
                  setRejectModalOpen(true);
                }}
                onPdf={(row, periodId) =>
                  FilesService.downloadConstancy(row.empleadoId, periodId)
                }
              />
            )}
          />
        </ThemeProvider>
      </Box>
      <RejectModal
        open={rejectModalOpen}
        onClose={() => setRejectModalOpen(false)}
        handleSubmit={handleRejectSubmit}
      />
      <ApproveModal
        open={approveModalOpen}
        onClose={() => setApproveModalOpen(false)}
        handleSubmit={handleApproveSubmit}
      />
      <OdsModal
        open={odsModalOpen}
        onClose={() => setOdsModalOpen(false)}
        year={year}
        branch={branch}
      />
      <BulkApprove
        employees={employeesFilter}
        onClose={() => {
          getEmployees();
          setBulkApproveModalOpen(false);
        }}
        open={bulkApproveModalOpen}
        year={year}
        sucursal={branch}
        showToast={showToast}
      />
      {selectedPeriod?.rowData && (
        <AgregarSolicitud
          open={editModalOpen}
          onClose={() => setEditModalOpen(false)}
          row={selectedPeriod.rowData}
          periodo={selectedPeriod.periodNumber}
          isEditMode={Boolean(selectedPeriod.periodId)}
          onSuccess={getEmployees}
          showToast={showToast}
        />
      )}

      {Toast}
    </Container>
  );
};

export default DataTable;
